import { Typography, TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { AutocompleteOption } from '../../../types/autocomplete'

export interface ReduxComboBoxProps {
  label: string
  input: any
  options: AutocompleteOption[]
  option: AutocompleteOption
  [key: string]: any
}

const ReduxComboBox = ({ label, input, options, ...custom }: any) => (
  <Autocomplete
    id='combo-box'
    value={input?.value?.value || null}
    options={options}
    onChange={(event: any, value: any) => {
      input.onChange(value?.value || '')
    }}
    onOpen={() => input.onBlur()}
    onClose={() => input.onBlur()}
    includeInputInList
    getOptionLabel={(option: AutocompleteOption) => option.label}
    style={{ width: 300 }}
    {...custom}
    renderInput={(params) => {
      return (
        <TextField
          label={label}
          placeholder={label}
          autoComplete='off'
          {...params}
        />
      )
    }}
    renderOption={(option: AutocompleteOption) => {
      return <Typography variant='body2'>{option.label}</Typography>
    }}
  />
)

export default ReduxComboBox
